var e = function e(_e, m, i) {
  var l;
  var d = !!["bodyMedium", "bodySmall"].includes(m) || void 0 === _e;
  return d ? d ? (l = function (e, m) {
    var i;
    return "mobile" !== m || "mobile" === m ? (i = {
      featureMedium: "medium",
      featureSmall: "medium",
      featureXSmall: "medium",
      title2XLarge: "medium",
      titleXLarge: "medium",
      titleLarge: "medium",
      titleMedium: "medium",
      titleSmall: "medium",
      bodyLarge: "medium",
      bodyMedium: "small",
      bodySmall: "small"
    }[e], i) : void 0;
  }(m, i), l) : void 0 : _e;
};
export { e as _findTooltipSize };